export default __webpack_public_path__ + "static/media/download.adc0167f.svg";